import { AxiosResponse } from "axios";

import { IOneMstsTest } from "../../@types/admin/AdminOneMsts";
import { api } from "../api";

/**
 * 1MSTS admin page (EN-5159), migrated from the Retool
 * OneMinuteSitToStandTest app.
 *
 * There is no download function here: the per-row Excel export goes through
 * `fileTransferService` / `useFileDownload` (EN-5148), which is the one place
 * that knows how to reject a non-2xx before anything reaches the disk.
 */
export const oneMstsService = {
  /** Every 1MSTS test, newest first. */
  async getOneMstsTests(): Promise<AxiosResponse<IOneMstsTest[]>> {
    return api.get<IOneMstsTest[]>("/Retool/OneMsts");
  },
};

/** URL of a single test's Excel export, for `useFileDownload`. */
export function oneMstsExportUrl(testId: string): string {
  return `/Retool/OneMsts/${testId}/Export`;
}
